import { useTranslation } from 'react-i18next'
import { UIConfigWithDatepicker } from '../shared/UIConfigWithDatepicker/UIConfigWithDatepicker'

export default function DayAheadOverview() {
  const { t } = useTranslation()

  return <UIConfigWithDatepicker type="day_ahead_overview" title={t('Day ahead overview')} defaultDay="tomorrow" />
}
